<!--
 * @Author: kangkang 1278279046@qq.com
 * @Date: 2022-05-26 16:36:20
 * @LastEditors: kangkang 1278279046@qq.com
 * @LastEditTime: 2022-11-15 13:39:35
 * @FilePath: \experience-pc\src\components\MinProgram.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="alert-box">
    <div class="f18 text-center">{{ title }}</div>
    <div class="img-box margin-top-20">
      <img :src="qrCode" alt="" />
      <!-- <img v-else src="@/assets/img/qr_code.jpg" alt="" /> -->
    </div>
    <div class="f12 text-color-666 text-center margin-top-20">{{subTitle}}</div>
  </div>
</template>
<script>
export default {
  name: "MinProgram",
  data() {
    return {
    qrCode:"https://cdn.kudianxue.cn/temp/20221115111435_1668482127594.jpg"
    };
  },

  props: {
    title: {
      type: String,
      default: "小程序二维码",
    },
    subTitle: {
      type: String,
      default: "扫码小程序，关注小程序",
    },
    // qrCode:{
    //   type:String,
    //   default:""
    // }
  },
};
</script>

<style lang="scss" scoped>
.alert-box {
  width: 300px;
  padding-top: 30px;
  padding-bottom: 30px;
  background: #fff;
}

.alert-box .img-box {
  display: flex;
  justify-content: center;
  align-items: center;
}
.alert-box .img-box img {
  width: 200px;
  height: 200px;
}
.text-center{
  text-align: center;
}

.margin-top-20{
  margin-top:20px;
}

.text-color-666{
  color: #666;
}
</style>


// WEBPACK FOOTER //
// src/components/MinProgram.vue